module.exports = __webpack_public_path__ + "static/brittan-canyon-zoom-0fefba3ede6ca3e7c2d513c1bd7c8082.jpg";